import videojs from "video.js";
import Player from "video.js/dist/types/player";

interface ConfirmationButtonPluginOptions {
  onConfirm: () => void;
  buttonText?: string;
  shouldShow: () => boolean;
}

export function confirmationButtonPlugin(
  this: any,
  options?: ConfirmationButtonPluginOptions,
) {
  const player = this;

  // Create a DOM element for the button
  const buttonEl = document.createElement("button");
  buttonEl.innerText = options?.buttonText || "Confirm";
  buttonEl.className = "vjs-end-confirm-button";
  buttonEl.style.display = "none"; // hide initially
  buttonEl.style.position = "absolute";
  buttonEl.style.top = "50%";
  buttonEl.style.left = "50%";
  buttonEl.style.transform = "translate(-50%, -50%)";
  buttonEl.style.zIndex = "9999";
  buttonEl.style.padding = "12px 24px";
  buttonEl.style.fontSize = "24px";
  buttonEl.style.backgroundColor = "oklch(56.02% 0.141 245.12)"; // color primary
  buttonEl.style.color = "white";
  buttonEl.style.border = "none";
  buttonEl.style.borderRadius = "4px";
  buttonEl.style.cursor = "pointer";

  // Add click handler
  buttonEl.addEventListener("click", () => {
    if (options?.onConfirm) options.onConfirm();
  });

  // Add button to the Video.js container
  player.el().appendChild(buttonEl);

  // Show the button when video ends
  player.on("ended", () => {
    if (options?.shouldShow()) {
      buttonEl.style.display = "block";
    }
  });

  // Hide button if video plays again
  player.on("play", () => {
    buttonEl.style.display = "none";
  });
}

// Register plugin
export function registerConfirmationButtonPlugin() {
  if (!videojs.getPlugin("confirmationButton")) {
    videojs.registerPlugin("confirmationButton", confirmationButtonPlugin);
  }
}

export interface PlayerWithConfirmationButton extends Player {
  confirmationButton(options: ConfirmationButtonPluginOptions): void;
}
